

export const frontMatter = {};
export const contentTitle = 'Icons';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-components-icons-mdx-edc.json'
export const assets = {

};

import {jsx as _jsx} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {RefToIntellijPlatform} from "@site/src/components/RefToIntellijPlatform.tsx";
import {Example} from "@site/src/components/ExampleContext";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    ..._provideComponents(),
    ...props.components
  };
  return _jsx(_components.header, {
    children: _jsx(_components.h1, {
      id: "icons",
      children: "Icons"
    })
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

